"use strict";

var _classCallCheck = require("/home/runner/work/listennit/listennit/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var UserList = function UserList(options, _r) {
  _classCallCheck(this, UserList);

  return options.children.map(function (user) {
    return _r._newObject('RedditUser', user);
  });
};

exports.default = UserList;